import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, UrlTree } from '@angular/router';
import { RedirectService } from 'src/app/services/redirect.service';
import { getFullPath } from '../lib/get-full-path';
import { BrowserService } from '../services/browser.service';

@Injectable({
  providedIn: 'root',
})
export class TenantAuthGuard  {
  constructor(private redirectService: RedirectService, private browserService: BrowserService) {}

  async canActivate(next: ActivatedRouteSnapshot): Promise<UrlTree | boolean> {
    const path = getFullPath(next);
    const query = next.queryParams;

    let url = this.browserService.getCorrectPicflowUrl();
    if (path.length) url += `/${path.join('/')}`;
    const queryString = new URLSearchParams(query).toString();
    if (queryString) url += `?${queryString}`;

    return this.redirectService.externalRedirectTo(url);
  }
}
